export const commonTranslations = {
    'km': 'km',
    'model': 'Malli',
    'customer_support_feedback': 'Asiakastuki ja palaute',
    'technical_error': 'Tekninen virhe, yritä myöhemmin uudelleen',
    'price_validate_zero': 'Hinta ei voi olla korkeampi kuin nolla.',
    'price_validate': 'Minimihinta ei voi olla korkeampi kuin Maksimihinta.',
    'invalid_request': 'Sivua ei löydy. Tarkista, että sivun osoite on oikein.',
    'no_record_found': 'Hakuehdoilla ei löytynyt yhtään ilmoitusta',
    'pcs': 'kpl',
    'month_short': 'kk',
    'add_to_favourite': 'Lisää suosikiksi',
    'add_to_favourite_double_line': 'Lisää<br />suosikiksi',
    'remove_from_favourite': 'Poista suosikeista',
    'remove_from_favourite_double_line': 'Poista<br />suosikeista',
    'added_to_compare_single_line': 'Lisätty vertailuun',
    'added_to_compare': 'Lisätty<br />vertailuun',
    'add_to_compare_single_line': 'Lisää vertailuun',
    'add_compare_single': 'Vertaa',
    'hide_from_search': 'Piilota kohde',
    'add_to_compare': 'Lisää<br />vertailuun',
    'show_less': 'Näytä vähemmän',
    'show_more': 'Näytä lisää',
    'missing_mandatory': 'Pakollista kenttää ei voi jättää tyhjäksi',
    'delete_confirmation': 'Oletko varma, että haluat poistaa?',
    'finance_offer': 'Rahoitus alk.',
    'finance_offer_short': 'alk.',
    'select': 'Valitse',
    'show_result': 'Näytä tulokset',
    'make': 'Merkki',
    'no_result_text': 'Ei hakutuloksia',
    'town': 'Paikkakunta',
    'no_lower_limit': 'Ei alarajaa',
    'no_upper_limit': 'Ei ylärajaa',
    'filter_cannot_use_with_id': 'ID-rajausta ei voi käyttää muiden ehtojen kanssa',
    'clear_previous_search': 'Tyhjennä edelliset haut',
    'previous_search': 'Edelliset haut',
    'any': 'Ei väliä',
    'invalid_email': 'Antamasi sähköpostiosoite ei kelpaa, ole hyvä ja tarkista se.',
    'invalid_max_emails': 'Voit antaa maksimissaan 10 osoitetta.',
    'select_minimum_ad_text': 'Valitse ainakin yksi ajoneuvo, jonka linkin haluat lähettää',
    'invalid_name': 'Nimi-kenttä on pakollinen täyttää.',
    'invalid_phone': 'Ole hyvä ja tarkista antamasi puhelinnumero.',
    'blank_form_submit_text': 'Tyhjää lomaketta ei hyväksytä',
    'country_finland': 'Suomi',
    'message_length_error': 'Viestin merkkimäärä on 1 - 1000 merkkiä.',
    'month_names': {
        '1': 'Tammikuu',
        '2': 'Helmikuu',
        '3': 'Maaliskuu',
        '4': 'Huhtikuu',
        '5': 'Toukokuu',
        '6': 'Kesäkuu',
        '7': 'Heinäkuu',
        '8': 'Elokuu',
        '9': 'Syyskuu',
        '10': 'Lokakuu',
        '11': 'Marraskuu',
        '12': 'Joulukuu',
    },
    'month_short_names': {
        '1': 'Tam',
        '2': 'Hel',
        '3': 'Maa',
        '4': 'Huh',
        '5': 'Tou',
        '6': 'Kes',
        '7': 'Hei',
        '8': 'Elo',
        '9': 'Syys',
        '10': 'Lok',
        '11': 'Mar',
        '12': 'Jou',
    },
    'days_long': ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'],
    'days': {
        'monday': 'Ma',
        'tuesday': 'Ti',
        'wednesday': 'Ke',
        'thursday': 'To',
        'friday': 'Pe',
        'saturday': 'La',
        'sunday': 'Su',
    },
    'year': 'Vuosi',
    'ad_detail': {
        'contact': {
            'add_favorite_dealer': 'Lisää suosikkiliikkeeksi',
            'remove_favorite_dealer': 'Suosikkiliike (poista)',
        },
        'finance': {
            'error': {
                'autoraha_max_loan_amount': 'Lainan maksimimäärä on 100 000€',
                'autoraha_min_loan_amount': 'Pienin lainasumma voi olla 3 000€',
                'etua_max_loan_amount': 'Lainan maksimimäärä on 100 000€',
                'etua_min_loan_amount': 'Pienin lainasumma voi olla 500€',
                'kattokorko_max_loan_amount': 'Lainan maksimimäärä on 100 000€',
                'kattokorko_min_loan_amount': 'Pienin lainasumma voi olla 500€',
                'op_max_amount': 'Lainan maksimimäärä on ',
                'op_min_amount': 'Pienin lainasumma voi olla ',
                'rahoituskumppani_min_loan_amount': 'Pienin lainasumma voi olla 51€',
                'santander_max_loan_amount': 'Lainan maksimimäärä on 50 000€',
                'santander_min_loan_amount': 'Pienin lainasumma voi olla 2000€',
                'rahoitustie_min_loan_amount': 'Pienin lainasumma voi olla 500€',
            },
        },
        'print_stats': {
            'dont_report_twice': 'Toimintoa voi käyttää vain kerran ilmoitusta kohden',
        },
    },
    'ad_post': {
        'saved': 'Luonnos tallennettu',
        'saving': 'Tallennetaan',
        'type_engine_model': 'Kirjoita mallitarkennus tähän',
        'charging_type': 'Lataustyyppi',
        'quick_list': 'Pikalista',
        'calendar': {
            'day': 'vrk',
            'days': 'Päivää',
            'next': 'Seuraava»',
            'previous': '«Edellinen',
            'week': 'viikko',
        },
        'error_message': {
            'address': 'Osoite on liian lyhyt, tarkista osoite.',
            'country': 'Valitse maa.',
            'delivery_cost': 'Toimistomaksu tulee olla numero ja suurempi kuin 0.',
            'delivery_cost_or_not_price': 'Anna toimistomaksu tai valitse Ei toimistomaksua.',
            'domicile': 'Valitse maakunta.',
            'fuel_type': 'Valitse käyttövoima.',
            'make': 'Valitse merkki.',
            'no_image': 'Lisää vähintään yksi kuva ajoneuvosta.',
            'price': 'Hintaan voi syöttää vain numeroita ja enintään 9 merkkiä.',
            'price_or_not_price': 'Anna hintapyyntö tai valitse ei hinnoiteltu.',
            'price_rent': 'Anna viikon vuokrahinta.',
            'town': 'Valitse paikkakunta.',
            'vin': 'Tarkista valmistenumero.',
            'year': 'Valitse vuosimalli.',
            'year_model_text': 'Oletko varmasti myymässä tämän vuoden mallia olevaa ajoneuvoa?',
            'numeric_format': 'Tähän kenttään ainostaan numeroita.',
            'power': 'Anna teho numeroina.',
            'register_number': 'Anna rekisterinumero tai ajoneuvon valmistenumero (VIN)',
            'road_worthy': 'Valitse tieliikennekelpoisuus.',
            'color': 'Valitse väri.',
            'color_type': 'Valitse värityyppi.',
            'drive_type': 'Valitse vetotapa.',
            'engine_size': 'Valitse moottoritilavuus.',
            'gear_type': 'Valitse vaihteiston tyyppi.',
            'model': 'Valitse malli.',
            'mileage': 'Anna mittarilukema numeroina. Mittarilukema ei voi olla 0.',
            'mileage_invalid': 'Tarkista mittarilukema.',
            'invalid_reg_no': 'Tarkista rekisterinumero.',
            'invalid_reg_no_or_vin': 'Tarkista rekisterinumero tai VIN',
            'location_text': 'Valitse sijainti.',
            'first_register_date': 'Valitse vuosi ja kuukausi.',
            'inspection_date': 'Päivämäärä ei voi olla tulevaisuudessa.',
            'inspection_month': 'Valitse vuosi ja kuukausi.',
            'too_new_inspection': 'Jos ensimmäinen katsastus on tulossa, jätä katsastusajankohta täyttämättä.',
            'model_type_word_length': 'Yhden sanan enimmäismerkkimäärä on 21.',
            'missing_mandatory': 'Pakollista kenttää ei voi jättää tyhjäksi',
            'warranty': 'Anna takuu numeroina.',
            'warranty_date': 'Anna takuun päättymispäivä muodossa pp.kk.vvvv tai kk.vvvv.',
            'usp_info_limit': 'Myyntikuvauksen enimmäispituus on 200 merkkiä',
            'first_usage_date': 'Anna käyttöönottopäivä muodossa pp.kk.vvvv.',
        },
        'image_360': {
            'attachment_text': 'Kuva lisätty onnistuneesti',
            'attachment_text_second': 'Enimmäismäärä (2 kuvaa) lisätty',
            'invalid_url': 'URL-osoitetta ei voitu vahvistaa. Tarkista linkki',
        },
        'video': {
            'delete_instruction': 'Oletko varma, että haluat poistaa videon ?',
            'invalid_url': 'Syötä toimiva videon osoite',
        },
    },
    'ad_review': {
        'read_more': 'Lue lisää',
        'show_less': 'Piilota',
        'thanks_for_feedback': 'Kiitos palautteestasi!',
        'error_message': {
            'select_star': 'Anna arvostelu jokaisesta osa-alueesta.',
            'selected_all_five': 'Annoit kaikista osa-alueista täydet 5/5 tähteä tälle automallille. Kerro vielä tarkemmin, miksi.',
            'selected_all_one': 'Annoit kaikista osa-alueista vain 1/5 tähteä tälle automallille. Kerro vielä tarkemmin, miksi.',
            'select_make': 'Valitse merkki.',
            'select_model': 'Valitse malli.',
            'year': 'Valitse vuosimalli.',
        },
    },
    'ad_status_change': {
        'showcase_warning': 'Ilmoituksella on aktiivinen Näyteikkuna korostus, jos muutat ilmoituksen tilaa myös korostus poistuu näkyvistä. Haluatko jatkaa?',
        'upsell_showcase_warning': 'Ilmoituksella on aktiiviset Ohituskaista ja Näyteikkuna korostukset, jos muutat ilmoituksen tilaa myös korostukset poistuvat näkyvistä. Haluatko jatkaa?',
        'upsell_warning': 'Ilmoituksella on aktiivinen Ohituskaista korostus, jos muutat ilmoituksen tilaa myös korostus poistuu näkyvistä. Haluatko jatkaa?',
        'error': {
            'less_price': 'Hinnan on oltava suurempi kuin 0',
            'price': 'Hintaan voi syöttää vain numeroita ja enintään 9 merkkiä.',
        },
    },
    'advance_dealer': {
        'edit_cancel_confirm': 'Oletko varma, että haluat keskeyttää tietojen muokkaamisen?',
        'footer_logo_limit_error': 'Voit valita enintään 10 palvelut logoa näkyville samanaikaisesti',
        'invalid_image_error': 'Lataa kelvollinen kuva',
        'no_image_uploaded_error': 'Ei ladattua kuvaa',
        'company_info': {
            'allow_text_limit_error': 'Otsikko sisältää enintään 50 merkkiä.',
        },
        'custom_page': {
            'page_name_empty_error': 'Ole hyvä ja anna sivun nimi',
            'page_title_empty_error': 'Ole hyvä ja anna vapaamuotoisen sisältösivun otsikko.',
            'page_url_empty_error': 'Ole hyvä ja anna vapaamuotoisen sisältösivun URL-osoite.',
        },
        'external_link': {
            'invalid_link_detail_error': 'Ole hyvä ja anna oikea ulkoisen linkin osoite.',
            'text_limit_error': 'Ulkoisen linkin pituus voi olla enintään 20 merkkiä.',
        },
        'front_page_introduction': {
            'allow_text_limit_error': 'Mainostiedot mahtuu vain 200 merkkiä',
        },
    },
    'advanced_search': {
        'outside_finland': 'Suomen ulkopuolella',
        'invalid_maximum_value': 'Maksimi tulee olla suurempi kuin minimi arvo',
        'invalid_minimum_value': 'Minimi tulee olla pienempi kuin maksimi arvo',
        'invalid_range_value': 'Sallittu arvo tulee olla välillä %min%-%max%',
        'multiple': 'Useita',
        'show_result': 'Hae',
    },
    'compare': {
        'add': 'Lisää vertailuun',
        'limit': 'Voit vertailla enintään 10 ajoneuvoa kerrallaan.',
        'remove': 'Poista vertailusta',
        'remove_all': 'Kaikki kohteet poistetaan vertailulistalta.',
        'added_to_compare_listing': 'Lisätty vertailuun',
        'title': 'Vertaile',
    },
    'dealer_person': {
        'added_success': 'Myyjätieto lisätty',
        'delete_confirm': 'Oletko varma, että haluat poistaa?',
        'delete_success': 'Henkilön tiedot tuhottu',
        'order_change': 'Järjestys vaihdettu onnistuneesti',
        'order_change_error': 'Virhe järjestystä vaihdettaessa',
        'rotation_disabled': 'Kierto pois päältä',
        'rotation_enabled': 'Kierto kytketty päälle',
        'updated_success': 'Henkilötiedot tallennettu',
        'error': {
            'address': 'Tarkista osoite.',
            'city': 'Tarkista kaupunki.',
            'enter_mobile_number': 'Anna matkapuhelinnumero Whatsappin käyttöä varten.',
            'image': 'Lataa kelvollinen kuva',
            'invalid_address': 'Osoite voi sisältää ainoastaan numeroita ja kirjaimia.',
            'invalid_city': 'Kaupunki voi sisältää ainoastaan kirjaimia.',
            'invalid_name': 'Nimi ei voi sisältää numeroita tai erikoismerkkejä.',
            'mobile': 'Tarkista matkapuhelinnumero.',
            'name': 'Anna nimi.',
            'phone': 'Tarkista puhelinnumero.',
            'title': 'Tehtävänimike ei voi sisältää numeroita tai erikoismerkkejä.',
        },
    },
    'edit_dealer': {
        'contact_request_message': 'Hei,%new_line%Olen kiinnostunut Alma Mobility Kauppiassivustosta',
        'edit_confirm_cancel': 'Oletko varma, että haluat keskeyttää tietojen muokkaamisen?',
        'fair': 'Kohtalainen',
        'invalid_delivery_cost': 'Toimistomaksu tulee olla numero ja suurempi kuin 0.',
        'invalid_facebook_page_url': 'Ole hyvä ja korjaa Facebook-sivujen osoite',
        'invalid_image': 'Lataa kelvollinen kuva',
        'long_contact_time_text': 'Tekstikenttään mahtuu korkeintaan 80 merkkiä',
        'long_introduction_text': 'Tekstikenttään mahtuu korkeintaan 500 merkkiä',
        'invalid_alma_password': 'Salasanan tulee olla pituudeltaan 8-128 merkkiä, sisältää sekä pieniä (a-z) että suuria (A-Z)kirjaimia ja sen tulee sisältää erikoismerkkejä tai numeroita.',
        'password_mandatory': 'Tallentaaksesi muutokset tietoihisi, sinun tulee kirjoittaa salasanasi.',
        'price_history_message': 'Huomaa, että sallimalla tämän, hintahistoria tullaan näyttämään kaikissa kohteissa.',
        'short': 'Liian lyhyt',
        'strong': 'Vahva',
        'weak': 'Heikko',
    },
    'favourite': {
        'remove_message': 'Haluatko varmasti poistaa kohteen suosikkilistalta?',
        'save_and_show_list': 'Tallenna ja näytä suosikit',
        'to_favorite_list': 'Näytä Suosikit',
    },
    'feedback': {
        'dealer_contact_form': 'Yrityskäyttäjän yhteydenottolomake',
        'seller_contact_form': 'Yksityiskäyttäjän yhteydenottolomake',
        'validate': {
            'account_option': 'Valitse ainakin yksi yhteydenoton aiheista.',
            'email_blank': '*Sähköpostiosoite* -kenttä on pakollinen täyttää.',
            'invalid_ad_ids': 'Vain pilkulla erotetut numerot ovat sallittuja',
            'issue_type': 'Ole hyvä ja valitse palautteen aihe.',
            'mobile_format': 'Ole hyvä ja tarkista antamasi kännykkänumero',
            'name_blank': '*Nimi* -kenttä on pakollinen täyttää.',
            'new_location_company_required': 'Yrityksen nimi on pakollinen',
            'new_location_address_required': 'Osoite on pakollinen',
            'new_location_phone_required': 'Puhelinnumero on pakollinen',
            'new_location_lead_email_required': 'Liidiosoite on pakollinen',
            'new_location_start_date_required': 'Aloituspäivä on pakollinen',
            'new_location_contact_name_required': 'Yhteyshenkilön nimi on pakollinen',
            'new_location_contact_email_required': 'Yhteyshenkilön sähköposti on pakollinen',
            'new_location_invalid_email': 'Virheellinen sähköpostiosoite',
            'new_location_invalid_phone': 'Virheellinen puhelinnumero',
            'new_location_invalid_ad_count': 'Ilmoitusmäärän täytyy olla kelvollinen numero',
        },
    },
    'login_modal': {
        'multiple_email_login': 'Antamallasi sähköpostiosoitteella ei voi kirjautua palveluun. Kokeile kirjautua käyttäjätunnuksellasi. Ongelmatilanteissa ota yhteyttä asiakaspalveluun.',
        'password_login_empty': 'Käyttäjätunnus tai salasana -kenttä on tyhjä',
        'pending_user': 'Et voi kirjautua sisään %vertical_name% on, koska et ole aktivoinut tiliäsi. Aktivoidaksesi tilisi, klikkaa linkkiä, joka on lähetetty sähköpostiisi heti rekisteröintisi jälkeen. Mikäli et ole saanut aktivointilinkkiä, ole hyvä ja klikkaa Unohditko salasanan? ja valitse Tarvitsetko apua tilin aktivoinnissa?',
        'wrong_password_login': 'Olet antanut väärän käyttäjätunnuksen tai salasanan. Muista, että käyttäjätunnus ja salasana tulee kirjoittaa täsmälleen oikein, eli muista ISOT ja pienet kirjaimet.',
        'terminate_user': `Mitätöity jäsen ei voi kirjautua palveluun. Ota yhteys asiakaspalveluun <a href='${Routing.generate('feedback')}'>Asiakastuki ja palaute</a>saadaksesi lisätietoja`,
        'dealerForceUpdate': 'Tietosi on päivitetty. Kirjaudu tilillesi uudella käyttäjänimellä ja salasanalla.',
    },
    'own_ad': {
        'select_at_least_one_ad': 'Ole hyvä ja valitse ainakin yksi ilmoitus',
        'show_statistic': 'Näytä tilastot',
        'hide_statistic': 'Piilota tilastot',
        'payment_receipt': {
            'mail_sent': 'Viesti on lähetetty onnistuneesti',
            'error': {
                'select_month': 'Valitse kuukausi',
                'select_site': 'Valitse portaali',
                'select_year': 'Anna rakennusvuosi',
            },
        },
    },
    'promotion_purchase': {
        'select_ad': 'Valitse ensin nostettava ilmoitus',
        'select_fastlane': 'Ole hyvä ja valitse korostus',
        'select_showcase': 'Ole hyvä ja valitse korostus',
    },
    'search_agent': {
        'agent_name_blank': 'Hakusi nimi ei saa olla tyhjä.',
        'search_agent_disabled': 'Hakuvahtisi on poistettu käytöstä, eikä sinulle lähetetä hakuvahtiviestejä. Voit aktivoida hakuagentin koska tahansa.',
        'search_agent_enabled': 'Kiitos vahvistuksesta, %site%.com hakuvahtisi on aktiivinen seuraavat kahdeksan viikkoa',
    },
    'sell_ad': {
        'invalid_outside_finland_ad': 'Varmennettun ilmoituksen sijainti on oltava Suomi',
        'check_register_number': 'Tarkista rekisterinumero',
        'oma_seller_post_only': 'OmaNettix-palvelun hinta-arvio on tarkoitettu vain yksityiskäyttäjille. Tutustu autoliikkeiden palveluihin nettix.fissä.',
        'mileage_invalid': 'Tarkista mittarilukema.',
    },
    'pricing_tool': {
        'search_instruction': '<strong>Hinnoittele oikein!</strong> Hinnoittelutyökalulla voit etsiä osto- tai myyntikohdettasi vastaavia ilmoituksia, niin myydyistä kuin myynnissä olevista.<br />Myytyjen kohteiden tiedot on kerätty viimeisen %show_period% kk:n ajalta. Voit tarkastella sekä yksityisten että yritysten ilmoituksia.',
    },
    'alma_tunnus': {
        'verification_email_sent': 'Uusi vahvistusviesti lähetetty.',
    },
    'dealer_force_update': {
        'enter_username': 'Kenttää ei voi jättää tyhjäksi.',
        'valid_username': 'Käyttäjänimen tulee olla 8-128 merkkiä. Se voi sisältää kirjaimia, numeroita ja erikoismerkkejä. Käyttäjänimi ei voi sisältää välilyöntejä.',
        'enter_new_password': 'Kenttää ei voi jättää tyhjäksi.',
        'valid_password': 'Salasanan tulee olla 8-128 merkkiä ja sisältää pieniä ja isoja kirjaimia sekä vähintään yksi numero tai erikoismerkki.',
        'enter_confirm_password': 'Kenttää ei voi jättää tyhjäksi.',
        'password_not_match': 'Salasanakentät eivät täsmää.',
    },
    'smart_sale': {
        'testimonial_1': 'Varmistin samalla ostajan tiedot, kauppa onnistui rahansiirtoineen heti päätöksen jälkeen vartissa.',
        'testimonial_2': 'Sähköisen kauppakirjan laatimisen ja koko myynti prosessin helppous, eli tarvinnut tulostaa mitään lappuja ja ostaja ja myyjä pysyivät kartalla, että mitä tapahtuu missäkin vaiheessa.',
        'testimonial_3': 'Turvallinen maksu sekä se, että ei ole tulostinta, joten sain kaikki tehtyä sähköisesti',
        'testimonial_4': 'Turvallinen kauppatapa. Toimi loistavasti ja rahat tuli nopeasti!',
        'testimonial_5': 'Ei tätä oikein paremmin tai luotettavammin voi hoitaa',
    },
    'inbox': {
        'invalid_price': 'Tarjoussumma vaaditaan',
        'offer_failed': 'Tarjouksen lähettäminen epäonnistui, ole hyvä ja yritä uudelleen',
    },
};
